import React, { useEffect } from "react";
import Modal from "../../components/modal";
import { DropDownInput } from "../../wrappers/selectInput";
import { FormInput } from "../../wrappers/formInput";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import Headline5 from "../../components/headings/Headline5";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

export type ShareLinkForm = {
  payPeriod: any;
  project: any;
  email: string;
};

interface Props {
    onClose?: any;
    projectData?: any;
    payPeriodData?: any;
    clickHandler?: any;
    getPayPeriod?: any;
    candidateEmail?: string;
}

const validationSchema = Yup.object({
  payPeriod: Yup.object().required("Field is required"),
  project: Yup.object().required("Field is required"),
  email: Yup.string().required("Field is required"),
});

const ShareLink = (props: Props) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
    // defaultValues: useMemo(() => {
    //   return defaultValues;
    // }, [defaultValues]),
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState,
  } = useForm<ShareLinkForm>(formOptions);

  const onSubmit = (data: any) => {
     props.clickHandler(data)
  };

  useEffect(() => {
    
    if (watch().project) {
     props.getPayPeriod(watch().project.projectId)
   }
   
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch().project])
  


  return (
    <Modal title={"shareLink"} onClose={props.onClose} size="medium">
      <form>
        <Headline5>Select the pay date range</Headline5>
        <div className="form-group">
          <div className="half-form-wrap">
            <div className="form-group no-label-datepicker">
              <label className="lablel">Project</label>
              <DropDownInput<ShareLinkForm>
                name="project"
                control={control}
                register={register}
                errors={formState.errors}
                data={props.projectData}
                dataItemKey='projectId'
                textField="projectName"
              />
            </div>
            <div className="form-group">
              <label className="lablel">Pay period</label>
              <DropDownInput<ShareLinkForm>
                name="payPeriod"
                control={control}
                register={register}
                errors={formState.errors}
                data={props.payPeriodData}
                dataItemKey='id'
                textField="name"
              />
            </div>
          </div>
        </div>
        <div className="form-group">
          <FormInput<ShareLinkForm>
            name="email"
            label="Only one email id allowed"
            register={register}
            errors={formState.errors}
            placeholder="Enter email here"
            defaultValue={props.candidateEmail}
          />
          <div className="subtext">
            Once submitted, the email id mentioned would be receiving a line
            through which they can enter their timesheet details and submit
          </div>
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={props.onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Send
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ShareLink;
